import OperatorApplicationAuth from "~/operatorApplication/vue/auth/OperatorApplicationAuth.vue";
import OperatorApplicationLayout from "~/operatorApplication/vue/layout/OperatorApplicationLayout.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {
    OPERATOR_APPLICATION_AUTH_ROUTE_NAME,
    OPERATOR_APPLICATION_ROOT_ROUTE_NAME
} from "~/operatorApplication/ts/router/OperatorApplicationRouteNames";
import RouteHelper from "~/core-ui/ts/router/RouteHelper";
import {createRouter, createWebHashHistory, RouteRecordRaw} from "vue-router";


let routes: RouteRecordRaw[] = [
    {
        name: OPERATOR_APPLICATION_AUTH_ROUTE_NAME,
        path: "/auth",
        component: OperatorApplicationAuth
    },
    {
        name: OPERATOR_APPLICATION_ROOT_ROUTE_NAME,
        path: "/",
        component: OperatorApplicationLayout
    }
];

RouteHelper.setDefaultRoutesComponents(routes);

let operatorApplicationRouter = createRouter({
    routes: routes,
    history: createWebHashHistory('/operator/application/'),
    linkExactActiveClass: "exact-selected",
    linkActiveClass: "selected"
});



operatorApplicationRouter.beforeEach(async (to, from, next) => {
    let isAuthorized = OperatorAccountStore.isAuthorized.value;
    if (isAuthorized) {
        if (to.name == OPERATOR_APPLICATION_AUTH_ROUTE_NAME) {
            return next({name: OPERATOR_APPLICATION_ROOT_ROUTE_NAME});
        }
    } else {
        if (to.name != OPERATOR_APPLICATION_AUTH_ROUTE_NAME) {
            return next({name: OPERATOR_APPLICATION_AUTH_ROUTE_NAME});
        }
    }
    return next();
});

export default operatorApplicationRouter;